import { useContext } from 'react';

import { SingleProductContext } from 'contexts';

import { Image } from 'components/Image';
import { Modal } from 'components/Modal';

import * as S from './ProductModal.styles';

type ProductModalProps = {
  title: string;
  url: string;
};

export function ProductModal(props: ProductModalProps): React.ReactElement {
  const { title, url } = props;

  const { isProductModalVisibleSet } = useContext(SingleProductContext);

  return (
    <Modal onClose={() => isProductModalVisibleSet(false)} asFullModal>
      <S.Container>
        <S.Title color="title" scale="xl3">
          {title}
        </S.Title>

        <S.ImageWrapper>
          <Image source={url} alt="product" />
        </S.ImageWrapper>
      </S.Container>
    </Modal>
  );
}
